
import AllInOneHelpWidget from 'derbysoft-all-in-one-help-widget';
interface WidgetIds {
    smartlookId: string,
    feedbackId: string,
    getGoogleAnalyticsId():string,
}
const WIDGET_ID_CONSTANT : WidgetIds = {
    getGoogleAnalyticsId: ()=> {return process.env.NODE_ENV == 'production' ? 'G-QHK6G07GP5' : 'G-F010M31WDF' },
    smartlookId: 'cef40ce59347b1183b3499b73a345f2968eb6197',
    feedbackId: '9180|17203|r8ZZqVDmCa0OBrmxWiAIfP5ab6JrZ1NldoVR1bxPIydgc32PzQ',
}
// Create an instance
const allInOneHelpWidget = new AllInOneHelpWidget();

// Initial GoogleAnalytics
allInOneHelpWidget.initGoogleAnalytics({
    id: WIDGET_ID_CONSTANT.getGoogleAnalyticsId(),
    enabled: true
});

// Initial Smartlook
allInOneHelpWidget.initSmartlook({
    id: WIDGET_ID_CONSTANT.smartlookId,
    enabled: true
});

// Initial Feedback
allInOneHelpWidget.initFeedback({
    id: WIDGET_ID_CONSTANT.feedbackId,
    enabled: true
});
export default allInOneHelpWidget;
